import React from "react";
import TextField from "./TextField";

const PrefixedTextField = ({ prefix, disabled, maxWidth, placeholder, value, onChange }) => {
    return (
        <div style={{
            display: "flex",
            alignItems: "center",
            flexGrow: "1",
            flex: "1",
            flexShrink: "0"
        }}>
            {prefix
                && <span style={{
                    height: "48px",
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "var(--grey-light)",
                    color: "var(--carbone)",
                    fontSize: "14px",
                    padding: "0 10px",
                    borderRadius: "6px 0 0 0"
                }}>
                    {prefix}
                </span>
            }
            <TextField
                disabled={disabled}
                maxWidth={maxWidth}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
            />
        </div>
    );
};

export default PrefixedTextField;
